import classNames from 'classnames/bind'
import { Element } from 'react-scroll'

const FormControlWrapper = props => (
  <div className={classNames({
    'field': true,
    'is-horizontal': props.horizontal,
    'with-error': props.error
  })}>
    {
      props.label &&
      <label className="label has-text-left">
        {props.label}
        {/* {props.required && "*"} */}
      </label>
    }
    <Element
      className={classNames({
        'control': true,
        'has-icons-left': props.icon
      })}
      name={props.name}
    >
      {props.children}
    </Element>
    {
      props.help && !props.error && <p className="help is-danger">{props.help}</p>
    }
    {
      props.error &&
      <p className="help is-danger">{props.error}</p>
    }
  </div>
)

FormControlWrapper.defaultProps = {
  disabled: false,
  size: 'small'
}

export default FormControlWrapper



// WEBPACK FOOTER //
// ./components/uiLib/FormControlWrapper/FormControlWrapper.jsx